/*
 * @Author: 陈乾
 * @Date: 2022-03-23 11:27:03
 * @LastEditors: 陈乾
 * @LastEditTime: 2025-09-19 09:34:41
 * @Description: file content
 */
const getters = {
  isLoading: state => state.loading.isLoading,
  userInfo: state => state.common.userInfo
}
export default getters
